import { render, staticRenderFns } from "./EditionCriterionManagement.vue?vue&type=template&id=044d7260"
import script from "./EditionCriterionManagement.vue?vue&type=script&lang=js"
export * from "./EditionCriterionManagement.vue?vue&type=script&lang=js"
import style0 from "./EditionCriterionManagement.vue?vue&type=style&index=0&id=044d7260&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports